export const select2SearchPaymentTypeCode = {
    placeholder: "",
    allowClear: true,
    minimumResultsForSearch: -1
}

export const select2SearchPaymentCurrency = {
    placeholder: "",
    allowClear: true,
    minimumResultsForSearch: -1
}

export const select2SearchPaymentStatus = {
    placeholder: "",
    allowClear: true,
    minimumResultsForSearch: -1
}
